import { Button, MenuItem, Select } from '@mui/material'
import { Typography, Fade  } from '@mui/material';
import React, { useEffect, useState } from 'react'
import "./EditRow.css"
import axiosApiInstance from '../axios';

const EditRow = ({ onStateChange, info, setIsDetailsChanged }) => {

  const [title, setTitle] = useState("");
  const [projects, setProjects] = useState([]);
  const [projectId, setProjectId] = useState(0);
  const [ticketId, setTicketId] = useState({});
  const [errMsg, setErrMsg] = useState('');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let timer;
    if (errMsg) {
      // Hide the message after 5 seconds
      timer = setTimeout(() => {
        setVisible(false);
        setErrMsg(''); // Clear the message after hiding
      }, 3000);
    }
    return () => clearTimeout(timer); // Cleanup timer on unmount
  }, [errMsg]);

  useEffect(() => {
    // add axios here
    axiosApiInstance.get(`/ticket/${info}`)
      .then(res => setTicketId((res.data.data))
      ).catch(err => console.log(err))
  }, [info])

  useEffect(() => {
    if (ticketId.categoryId) {
      getSubCategoryList(ticketId.categoryId);
    }
    setTitle(ticketId.title);
    setProjectId(ticketId.projectId);
    setPriorityId(ticketId.priorityId);
    setCategoryId(ticketId.categoryId);
    setSubCategoryId(ticketId.subCategoryId);
  }, [ticketId]);


  useEffect(() => {
    axiosApiInstance.get(`/project`)
      .then(req => setProjects(req.data.data))
  }, [])

  const inputEvent3 = (event) => {
    setProjectId(event.target.value)
  };

  const [priorityId, setPriorityId] = useState(0);
  const [categories, setCategories] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const [categoryId, setCategoryId] = useState(0)
  const [subCategoryId, setSubCategoryId] = useState(0)

  useEffect(() => {
    axiosApiInstance.get(`/category`)
      .then(resp => setCategories(resp.data.data))
  }, [])

  const getSubCategoryList = (id) => {
    axiosApiInstance
      .get(`/subCategory/${id}`)
      .then((resp) => setSubCategories(resp.data.data));
  };

  const inputEvent = (event) => {
    getSubCategoryList(event.target.value);
    setSubCategoryId(0);
    setCategoryId(event.target.value)
  };

  const inputEventSubCategory = (event) => {
    setSubCategoryId(event.target.value);
  };

  let data = JSON.stringify({
    "id": info,
    "title": title === "" ? ticketId.title : title,
    "projectId": projectId === 0 ? ticketId.projectId : projectId,
    "priorityId": priorityId === 0 ? ticketId.priorityId : priorityId,
    "categoryId": categoryId === 0 ? ticketId.categoryId : categoryId,
    "subCategoryId": subCategoryId,
  });

  const saveDetails = () => {
    axiosApiInstance.patch('/ticket/Update', data).then(function (response) {
      console.log(response)
      if (response.data.succeeded) {
        setIsDetailsChanged(true);
        onStateChange();
      }else{
        setErrMsg(response.data.message)
      }

    }).catch((error) => {
      console.error("Error:", error);
      onStateChange();
  });

    
  }

  return (
    <>
      <div className="edit">

        <input className="input_title"
          type="text"
          id="Title"
          name="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Edit Title"
        />

        <Select className="sel_projectId"
          value={projectId}
          displayempty="true"
          name="projectTag"
          onChange={inputEvent3}
        >
          <MenuItem value={0} disabled>Edit Project Tag</MenuItem>
          {
            projects.map((pro, id) => (
              <MenuItem key={id} value={pro.id}>{pro.name}</MenuItem>
            )
            )
          }
        </Select>


        <Select className="sel_priority"
          value={priorityId}
          onChange={(e) => { (setPriorityId(e.target.value)) }}>
          <MenuItem value={0} disabled >Edit Priority</MenuItem>
          <MenuItem value={1}>Low</MenuItem>
          <MenuItem value={3}>Medium</MenuItem>
          <MenuItem value={2}>High</MenuItem>
        </Select>

        <Select className="sel_category"
          displayempty
          name="category"
          value={categoryId}
          onChange={inputEvent}
        >
          <MenuItem value="0" disabled>Edit Category</MenuItem>
          {categories.map((cat, id) => (
            <MenuItem key={id} value={cat.id}>{cat.name}</MenuItem>
          ))
          }
        </Select>

        <Select className="sel_category"
          displayempty
          name="category"
          value={subCategoryId}
          disabled={categoryId === 0}
          onChange={inputEventSubCategory}
        >
          <MenuItem value="0" disabled>Edit Sub Category</MenuItem>
          {subCategories.map((cat, id) => (
            <MenuItem key={id} value={cat.id}>{cat.name}</MenuItem>
          ))
          }
        </Select>
          <Fade in={true} timeout={{ enter: 500, exit: 3000 }}>
            <Typography variant="body2" color="error" sx={{ mt: 1 }}>
              {errMsg}
            </Typography>
          </Fade>
      </div>
      <Button className="edit-save" onClick={saveDetails}>Save</Button>
      <Button className="edit-cancel" onClick={onStateChange}>Cancel</Button>

    </>
  )
}

export default EditRow
